"use client";
import React from "react";
import { Navbar } from "@/components/Navbar";
import { Footer } from "@/components/Footer";
import { Slide } from "@/components/slide";
import { HomeAbout } from "@/components/home/HomeAbout";
import { HomeBrand } from "@/components/home/HomeBrand";
import { HomeProducts } from "@/components/home/HomeProducts";
import { HomeContact } from "@/components/home/HomeContact";

export default function Page() {
  return (
    <div>
      <Navbar />
      
      {/* Hero slide */}
      <Slide />
      
      {/* Componentes con loading interno */}
      <HomeAbout />
      <HomeBrand />
      <HomeProducts />
      <HomeContact />
      
      <Footer />
    </div>
  );
}
